import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { LoaderService } from '../services/loader.service';
import { SachLoginService } from 'src/app/onelog/services/sach-login.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private userDetails: UserDetailsService,
    private loaderService: LoaderService,
    private sachLoginService: SachLoginService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    
    
    return next.handle(request).pipe(
      map((res) => {
        
        return res;
      }),
      catchError((error: HttpErrorResponse) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        } else {
          console.log(error); // will remove in next commit
          errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
          if (error.status == 401) {
            let accessKey = this.userDetails.getAccessKey();
            this.userDetails.destoryUserDetails();
            this.router.navigate(['/login']);
            //this.userDetails.destoryUserDetails();

            //Not needed since this will give access to unauthorised user when redirected from sach
            // if (error.error.error == 'access_denied') {
            //   //console.log("here inside error access_denied");
            //   this.sachLoginService.login(accessKey).subscribe((data: any) => {
            //     let loginDetails = data;
            //     if (loginDetails.access_token) {
            //       this.userDetails.setUserDetails(
            //         loginDetails.access_token,
            //         loginDetails.user_id,
            //         accessKey
            //       );

            //       this.router.navigate(['/list-reports']);
            //     }
            //   });
            // }
            //this.router.navigate(['/login']);
          }
        }
        //this.loaderService.hide();
        return throwError(errorMsg);
      })
    );
  }
}
